/**
 * 1.9.1: timecodes typed or stored as source timecode, read back as media time. A recording that runs past midnight
 * (23:30 to 00:40) shows 00:10:00:00 after midnight; read back, a timecode earlier than the start that falls within
 * the media on the next day is read so (contracts parseTimecodeAfter). Used by the Player's programme marks and Log.
 */
import { parseTimecodeAfter, sourceTimecodeTicks, type Rational } from '@prism/contracts';

/** A programme timecode as seconds into the media, within [0, durationSec]; null when it is not a timecode. */
export function programmeSeconds(tc: string | null | undefined, rate: Rational, startFrames: number, durationSec: number): number | null {
  if (!tc) return null;
  const frameSec = rate.den / rate.num;
  const f = parseTimecodeAfter(tc, rate, startFrames, durationSec > 0 ? Math.ceil(durationSec / frameSec) : null);
  return f == null ? null : Math.max(0, Math.min(durationSec, (f - startFrames) * frameSec));
}

/** A typed timecode (Log's In and Out) as ticks of media time, never before 0; null when it is not a timecode. */
export function timecodeToMediaTicks(value: string, rate: Rational, startFrames: number, durationTicks: number | null | undefined): number | null {
  return sourceTimecodeTicks(value, rate, startFrames, durationTicks);
}
